import { __decorate } from "tslib";
//NPM
import { Component, Mixins } from "vue-property-decorator";
import { toaster } from "@/utilities/toaster";
//SYSTEM 1
import Loader from "@/components/widgets/loader.vue";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import TeamModule from "@/store/modules/team.module";
import DeleteComponent from "@/components/deleteComponent.vue";
let TeamsListing = /** @class */ (() => {
    let TeamsListing = class TeamsListing extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.title = "Teams List";
            this.items = [
                {
                    text: "Home",
                    href: "#",
                },
                {
                    text: "Teams List",
                    active: true,
                },
            ];
            this.deleteButton = false;
            this.pageIsLoading = true;
            this.showDeleteModal = false;
            this.teamName = "";
        }
        // COMPUTED
        get teams() {
            return TeamModule.teams;
        }
        // LIFECYCLE
        created() {
            TeamModule.GetTeams().then((response) => {
                if (response) {
                    this.pageIsLoading = false;
                }
            });
        }
        deleteTeam(teamId) {
            this.teamId = teamId;
            for (var i = 0; i < Object.keys(TeamModule.teams).length; i++) {
                if (TeamModule.teams[i].teamId === teamId) {
                    this.teamName = TeamModule.teams[i].teamName;
                }
            }
            this.deleteButton = false;
            this.showDeleteModal = true;
        }
        deleteYes() {
            TeamModule.DeleteTeamById(this.teamId).then((res) => {
                if (res) {
                    this.pageIsLoading = true;
                    toaster.ShowSuccess(`Team was deleted successfully.`);
                    TeamModule.GetTeams().then((response) => {
                        if (response) {
                            this.pageIsLoading = false;
                        }
                    });
                }
                else {
                    toaster.ShowError("Unable to delete the Team.");
                }
            });
            this.showDeleteModal = false;
        }
        cancelDelete() {
            this.showDeleteModal = false;
        }
    };
    TeamsListing = __decorate([
        Component({
            name: "TeamsListing",
            components: {
                Layout,
                PageHeader,
                Loader,
                DeleteComponent,
            },
        })
    ], TeamsListing);
    return TeamsListing;
})();
export default TeamsListing;
